import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import YouTube from 'react-youtube';
import IconPlus from "../../../../components/Icons/IconPlus";

const JoinUs = () => (
    <Container tag="section" className="join-us py-5">
        <Row>
            <Col tag="article" xs="12" className="text-center pb-5">
                <h2 className="title">Sumate a nuestros cursos online.</h2>
            </Col>
            <Col tag="article" lg="6">
                <p>De nuestra pasión por la gestión y el desarrollo de <strong>negocios dentro del fútbol nace la iniciativa de formar y capacitar</strong> a quienes buscan aprender más sobre cómo <strong>desenvolverse de manera eficiente, profesional y exitosa</strong> en una industria cada vez más cambiante y competitiva.</p>
                <Row tag="article" className="join-us__features text-center text-lg-start">
                    <Col lg="6" className="order-1 order-lg-0">
                        <hr/>
                        <p>Ponentes líderes de la industria del deporte</p>
                        <hr/>
                        <p>Grupos de networking</p>
                        <hr/>
                    </Col>
                    <Col lg="6" className="order-0 order-lg-1">
                        <hr/>
                        <p>Programas 100% Online</p>
                        <hr/>
                        <p>Prácticas en clubes de fútbol</p>
                        <hr/>
                        <p>Contenidos actualizados</p>
                    </Col>
                </Row>
            </Col>
            <Col tag="article" lg="6" className="text-center">
                <YouTube
                    videoId="MPC3kkLgY9E"
                    opts={{
                        width: '415',
                        height: '416',
                    }}
                />
            </Col>
            <Col tag="article" xs="12" className="text-center pt-5">
                <a href="/contacto" className="btn__cta">
                    <IconPlus width={66} height={66} />
                    <span>Solicitar información</span>
                </a>
            </Col>
        </Row>
    </Container>
);

export default JoinUs;